export const RECEIVE_ARTICLE_DETAILS = 'RECEIVE_ARTICLE_DETAILS';
